/**
 * hcaptcha.js
 * Universal hCaptcha loader + global callbacks for all Alpine forms.
 * Auto-bundled by Vite — do NOT import manually.
 *
 * Automatically scans for [data-sitekey] containers on DOMContentLoaded,
 * lazy-loads the hCaptcha API script via IntersectionObserver, and updates
 * any Alpine component that exposes a `hcaptchaCompleted` property.
 */

function _loadHcaptcha() {
    if (window.hcaptchaScriptLoaded) return;
    window.hcaptchaScriptLoaded = true;
    const s = document.createElement('script');
    s.src = 'https://js.hcaptcha.com/1/api.js';
    s.async = true;
    s.defer = true;
    s.onload = () => window.dispatchEvent(new Event('hcaptchaLoaded'));
    document.head.appendChild(s);
}

function _updateAlpineForms(completed, token) {
    document.querySelectorAll('[x-data]').forEach(el => {
        const data = el._x_dataStack?.[0];
        if (!data || typeof data.hcaptchaCompleted === 'undefined') return;
        data.hcaptchaCompleted = completed;
        if (typeof data.checkFormValidity === 'function') data.checkFormValidity();
    });
    if (window.formValidator && typeof window.formValidator.hcaptchaCompleted !== 'undefined') {
        window.formValidator.hcaptchaCompleted = completed;
        if (typeof window.formValidator.updateButtonState === 'function') window.formValidator.updateButtonState();
    }
}

window.onHcaptchaSuccess = function (token) {
    const f = document.getElementById('hcaptcha-response');
    if (f) f.value = token;
    _updateAlpineForms(true);
};

window.onHcaptchaExpired = function () {
    const f = document.getElementById('hcaptcha-response');
    if (f) f.value = '';
    _updateAlpineForms(false);
};

window.onHcaptchaError = function () {
    const f = document.getElementById('hcaptcha-response');
    if (f) f.value = '';
    _updateAlpineForms(false);
};

document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('[data-sitekey]');
    if (!containers.length) return;

    const load = () => _loadHcaptcha();

    if ('IntersectionObserver' in window) {
        containers.forEach(container => {
            const obs = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) { obs.disconnect(); load(); }
            }, { threshold: 0.1 });
            obs.observe(container);
        });
    } else {
        load();
    }

    function updateTheme() {
        const theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        document.querySelectorAll('[data-sitekey]').forEach(c => {
            c.setAttribute('data-theme', theme);
            if (typeof hcaptcha !== 'undefined') { try { hcaptcha.reset(); } catch (e) {} }
        });
    }
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', updateTheme);
});
